import Reveal, { Eyebrow } from "@/components/Reveal";
import Newsletter from "@/components/Newsletter";

const SECTIONS = [
  {
    id: "how-it-works",
    title: "How affiliate partnerships work",
    body: [
      "Venture & Stay participates in affiliate programs with travel partners including hotel booking platforms, tour operators, luggage and accessory brands, eSIM providers, and travel insurance marketplaces.",
      "When you click certain links on this site and make a booking or purchase, we may earn a commission from the partner. This happens at no additional cost to you — the price you pay is the same whether you use our link or navigate to the partner directly.",
    ],
  },
  {
    id: "editorial-independence",
    title: "Editorial independence",
    body: [
      "Commissions never determine what we recommend or how we rank it. We choose partners because they align with our editorial content, not because they promise the highest payout. Where a product or property has limitations, we say so plainly.",
      "Our comparisons reflect independent research, traveler feedback, and practical considerations such as location, amenities, service quality, and overall value.",
    ],
  },
  {
    id: "pricing",
    title: "Prices and availability",
    body: [
      "Prices shown on this site are indicative starting points gathered at the time of writing. Travel pricing changes constantly, and the final price is always confirmed on the partner's website before you book.",
    ],
  },
  {
    id: "privacy",
    title: "Privacy, in brief",
    body: [
      "If you join the Venture List, we store your email address solely to send our monthly travel-planning email. We do not sell or share your address with third parties, and every email includes a way to unsubscribe.",
      "Outbound partner links may include tracking parameters set by the partner so bookings can be attributed. Those partners' own privacy policies apply once you leave our site.",
    ],
  },
  {
    id: "contact",
    title: "Questions",
    body: [
      "For questions about our disclosure practices, partnerships, or privacy approach, write to Ventureandstay@gmail.com.",
    ],
  },
];

export default function Disclosure() {
  return (
    <div data-testid="disclosure-page">
      <section className="relative grain-overlay overflow-hidden">
        <div className="absolute top-0 right-1/3 h-[360px] w-[360px] rounded-full bg-ocean/10 blur-3xl" aria-hidden="true" />
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-36 sm:pt-44 pb-16">
          <Reveal>
            <Eyebrow>Transparency</Eyebrow>
            <h1 className="mt-4 font-serif text-4xl sm:text-5xl lg:text-6xl text-navy tracking-tight leading-[1.08]">
              Affiliate Disclosure <span className="italic text-ocean">&amp; Privacy</span>
            </h1>
            <p className="mt-6 text-base sm:text-lg text-charcoal/75 leading-relaxed max-w-2xl">
              Trust is the whole product here. This page explains — in plain language — how Venture &amp; Stay
              earns money and how we handle your information.
            </p>
          </Reveal>
        </div>
      </section>
      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pb-24 sm:pb-28">
        <div className="space-y-6">
          {SECTIONS.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.06}>
              <section
                id={s.id}
                data-testid={`disclosure-${s.id}`}
                className="rounded-3xl bg-white border border-slateblue/15 p-8 sm:p-10"
              >
                <p className="font-mono text-xs text-gold tracking-[0.24em]">{String(i + 1).padStart(2, "0")}</p>
                <h2 className="mt-3 font-serif text-2xl sm:text-3xl text-navy">{s.title}</h2>
                {s.body.map((p, j) => (
                  <p key={j} className="mt-4 text-sm sm:text-base text-charcoal/75 leading-relaxed">
                    {p}
                  </p>
                ))}
              </section>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.15}>
          <p className="mt-8 text-xs text-slateblue" data-testid="disclosure-updated">
            Last updated: July 2026.
          </p>
        </Reveal>
      </section>
      <Newsletter />
    </div>
  );
}
